/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".warning[_ngcontent-%COMP%]{width:100%;border:1px solid red;padding:7px;margin-bottom:20px}.warning[_ngcontent-%COMP%]   legend[_ngcontent-%COMP%]{width:auto;padding:2px;margin:0 0 0 5px;font-size:120%;font-weight:700}"];
export { styles as styles };
